import { TcmPresenterForFilterPane } from './tcm_presenter_filter_pane'

export default TcmPresenterForFilterPane